import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CircleCheck } from 'lucide-react';
import { Trans, useTranslation } from 'react-i18next';
import { useCountdown } from '@/hooks/useCountdown';
import { formatMinutesSecondsMMSS } from '@/util/utils';
import { Swimmlane } from '../ChatEvent/Swimmlane';
export const Resolve = ({ keepAlive }) => {
    const { minutes, seconds } = useCountdown(keepAlive);
    const { t } = useTranslation();
    const formattedTime = formatMinutesSecondsMMSS(minutes, seconds);
    return (_jsxs(Swimmlane, { className: "ml-0 flex h-[44px] max-w-sm items-center gap-2", children: [_jsx(CircleCheck, { size: 16, color: "var(--color-successful)" }), _jsxs("div", { className: "text-bold flex flex-col gap-0 text-left", children: [_jsx("p", { className: "text-sm font-medium", children: t('events.resolved.title') }), _jsx("div", { children: _jsx("span", { className: "text-foreground-muted text-xs font-normal", children: _jsx(Trans, { i18nKey: "events.resolved.subtitle", values: { time: formattedTime }, components: [
                                    _jsx("span", { className: "text-foreground-muted text-xs font-semibold" }, "time"),
                                ] }) }) })] })] }));
};
